const guards = {
  isUserNotConfirmed: (_, {data: {code}}) => code === "UserNotConfirmedException",
  isPasswordResetRequired: (_, {data: {code}}) => code === "PasswordResetRequiredException",
  isNewPasswordRequired: (_, {data: {challengeName}}) => "NEW_PASSWORD_REQUIRED" === challengeName,
};

export default guards;
